// Switch whole areas of the app on or off. Set padel to true to bring it back.
export const FEATURES = {
  padel: false,
};
